<template>
  <div class="reporting_head">
    <h1 class="heading">
      Reporting
    </h1>

    <div
      v-if="table === 'reports'"
      class="report_btns"
    >
      <div class="btn_grp">
        <a
          v-if="user && schedules && schedules.length > 0 && user.show_scheduler"
          class="btn btn_md secondary_btn"
          href="javascript:;"
          @click="switchTables('schedules')"
        >
          <svg
            fill="none"
            height="14"
            viewBox="0 0 14 14"
            width="14"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25Z"
              stroke="white"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
            <path
              d="M7 3.9375V7H10.0625"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
          </svg>
          <span class="heading_h5 font_bold">My Schedules</span>
        </a>
        <a
          v-if="canEditTemplates"
          class="btn btn_md primary_btn ml_8"
          href="javascript:;"
          @click="switchTables('templates')"
        >
          <svg
            fill="none"
            height="23"
            viewBox="0 0 21 23"
            width="21"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7497 21.125H3.93652C3.76248 21.125 3.59556 21.0526 3.47248 20.9236C3.34941 20.7947 3.28027 20.6198 3.28027 20.4375V5.3125C3.28027 5.13016 3.34941 4.9553 3.47248 4.82636C3.59556 4.69743 3.76248 4.625 3.93652 4.625H11.8122L16.4059 9.4375V20.4375C16.4059 20.5278 16.3889 20.6172 16.356 20.7006C16.323 20.784 16.2746 20.8598 16.2137 20.9236C16.1528 20.9875 16.0804 21.0381 16.0008 21.0727C15.9212 21.1072 15.8358 21.125 15.7497 21.125Z"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M5.90625 4.625V2.5625C5.90625 2.38016 5.97539 2.2053 6.09846 2.07636C6.22153 1.94743 6.38845 1.875 6.5625 1.875H14.4381L19.0319 6.6875V17.6875C19.0319 17.7778 19.0149 17.8672 18.9819 17.9506C18.949 18.034 18.9006 18.1098 18.8397 18.1736C18.7787 18.2375 18.7064 18.2881 18.6268 18.3227C18.5472 18.3572 18.4618 18.375 18.3756 18.375H16.4062"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M11.8125 4.625V9.4375H16.4069"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
          </svg>
          <span class="heading_h5 font_bold">My Templates</span>
        </a>
        <a
          v-if="reports && reports.length > 0 && canEditReports"
          class="btn btn_md secondary_btn ml_8"
          href="javascript:;"
          @click="$emit('create', 'report')"
        >
          <svg
            fill="none"
            height="23"
            viewBox="0 0 21 23"
            width="21"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.4064 19.75H4.59326C4.41921 19.75 4.25229 19.6776 4.12922 19.5487C4.00615 19.4197 3.93701 19.2449 3.93701 19.0625V3.93752C3.93701 3.75518 4.00615 3.58031 4.12922 3.45138C4.25229 3.32245 4.41921 3.25002 4.59326 3.25002H12.4689L17.0627 8.06252V19.0625C17.0627 19.1528 17.0457 19.2422 17.0127 19.3256C16.9797 19.409 16.9314 19.4848 16.8704 19.5487C16.8095 19.6125 16.7372 19.6631 16.6575 19.6977C16.5779 19.7322 16.4926 19.75 16.4064 19.75Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M12.4688 3.25002V8.06252H17.0632"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M8.53125 13.5625H12.4688"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M10.5 11.5001V15.6251"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
          </svg>
          <span class="heading_h5 font_bold">Create Report</span>
        </a>
      </div>
    </div>

    <div
      v-if="table === 'templates'"
      class="template_btns"
    >
      <div class="flex">
        <a
          id="to_report"
          class="btn btn_md primary_btn"
          href="javascript:;"
          @click="switchTables('reports')"
        >
          <svg
            fill="none"
            height="23"
            viewBox="0 0 22 23"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.9064 19.75H5.09326C4.91921 19.75 4.75229 19.6776 4.62922 19.5487C4.50615 19.4197 4.43701 19.2449 4.43701 19.0625V3.93752C4.43701 3.75518 4.50615 3.58031 4.62922 3.45138C4.75229 3.32245 4.91921 3.25002 5.09326 3.25002H12.9689L17.5627 8.06252V19.0625C17.5627 19.1528 17.5457 19.2422 17.5127 19.3256C17.4797 19.409 17.4314 19.4848 17.3704 19.5487C17.3095 19.6125 17.2372 19.6631 17.1575 19.6977C17.0779 19.7322 16.9926 19.75 16.9064 19.75Z"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M12.9688 3.25002V8.06252H17.5632"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M8.375 12.1875H13.625"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.6"
            />
            <path
              d="M8.375 14.9375H13.625"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.6"
            />
          </svg>
          <span class="heading_h5 font_bold">My Reports</span>
        </a>
        <a
          v-if="canEditTemplates"
          class="btn btn_md secondary_btn ml_8"
          href="javascript:;"
          @click="$emit('create', 'template')"
        >
          <svg
            fill="none"
            height="23"
            viewBox="0 0 21 23"
            width="21"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7497 21.125H3.93652C3.76248 21.125 3.59556 21.0526 3.47248 20.9236C3.34941 20.7947 3.28027 20.6198 3.28027 20.4375V5.3125C3.28027 5.13016 3.34941 4.9553 3.47248 4.82636C3.59556 4.69743 3.76248 4.625 3.93652 4.625H11.8122L16.4059 9.4375V20.4375C16.4059 20.5278 16.3889 20.6172 16.356 20.7006C16.323 20.784 16.2746 20.8598 16.2137 20.9236C16.1528 20.9875 16.0804 21.0381 16.0008 21.0727C15.9212 21.1072 15.8358 21.125 15.7497 21.125Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M5.90601 4.625V2.5625C5.90601 2.38016 5.97515 2.2053 6.09822 2.07636C6.22129 1.94743 6.38821 1.875 6.56226 1.875H14.4379L19.0316 6.6875V17.6875C19.0316 17.7778 19.0147 17.8672 18.9817 17.9506C18.9487 18.034 18.9004 18.1098 18.8394 18.1736C18.7785 18.2375 18.7062 18.2881 18.6265 18.3227C18.5469 18.3572 18.4616 18.375 18.3754 18.375H16.406"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M11.8123 4.625V9.4375H16.4067"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
          </svg>
          <span class="heading_h5 font_bold">Create Template</span>
        </a>
      </div>
    </div>

    <div
      v-if="table === 'schedules'"
      class="schedule_btns"
    >
      <div class="flex">
        <a
          id="to_report"
          class="btn btn_md primary_btn"
          href="javascript:;"
          @click="switchTables('reports')"
        >
          <svg
            fill="none"
            height="23"
            viewBox="0 0 22 23"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.9064 19.75H5.09326C4.91921 19.75 4.75229 19.6776 4.62922 19.5487C4.50615 19.4197 4.43701 19.2449 4.43701 19.0625V3.93752C4.43701 3.75518 4.50615 3.58031 4.62922 3.45138C4.75229 3.32245 4.91921 3.25002 5.09326 3.25002H12.9689L17.5627 8.06252V19.0625C17.5627 19.1528 17.5457 19.2422 17.5127 19.3256C17.4797 19.409 17.4314 19.4848 17.3704 19.5487C17.3095 19.6125 17.2372 19.6631 17.1575 19.6977C17.0779 19.7322 16.9926 19.75 16.9064 19.75Z"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M12.9688 3.25002V8.06252H17.5632"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M8.375 12.1875H13.625"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.6"
            />
            <path
              d="M8.375 14.9375H13.625"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.6"
            />
          </svg>
          <span class="heading_h5 font_bold">My Reports</span>
        </a>
        <a
          v-if="canEditTemplates"
          class="btn btn_md primary_btn ml_8"
          href="javascript:;"
          @click="switchTables('templates')"
        >
          <svg
            fill="none"
            height="23"
            viewBox="0 0 21 23"
            width="21"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7497 21.125H3.93652C3.76248 21.125 3.59556 21.0526 3.47248 20.9236C3.34941 20.7947 3.28027 20.6198 3.28027 20.4375V5.3125C3.28027 5.13016 3.34941 4.9553 3.47248 4.82636C3.59556 4.69743 3.76248 4.625 3.93652 4.625H11.8122L16.4059 9.4375V20.4375C16.4059 20.5278 16.3889 20.6172 16.356 20.7006C16.323 20.784 16.2746 20.8598 16.2137 20.9236C16.1528 20.9875 16.0804 21.0381 16.0008 21.0727C15.9212 21.1072 15.8358 21.125 15.7497 21.125Z"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M5.90625 4.625V2.5625C5.90625 2.38016 5.97539 2.2053 6.09846 2.07636C6.22153 1.94743 6.38845 1.875 6.5625 1.875H14.4381L19.0319 6.6875V17.6875C19.0319 17.7778 19.0149 17.8672 18.9819 17.9506C18.949 18.034 18.9006 18.1098 18.8397 18.1736C18.7787 18.2375 18.7064 18.2881 18.6268 18.3227C18.5472 18.3572 18.4618 18.375 18.3756 18.375H16.4062"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
            <path
              d="M11.8125 4.625V9.4375H16.4069"
              stroke="#37B2A8"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.69"
            />
          </svg>
          <span class="heading_h5 font_bold">My Templates</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: {
    table: {
      type: String,
      required: true,
    }
  },
  emits: ['create', 'update:table'],
  computed: {
    ...mapState('reports', ['reports']),
    ...mapState('user', ['user']),
    ...mapState('reportSchedules', ['schedules']),
    canEditReports() {
      return this?.user?.permissions?.reports_permission === 'EDIT' ?? false;
    },
    canEditTemplates() {
      return this?.user?.permissions?.report_templates_permission === 'EDIT' ?? false;
    },
  },
  methods: {
    switchTables(table) {
      switch(table) {
        case 'templates':
          window.mixpanel('Report Builder: View templates');
          break;
        case 'schedules':
          window.mixpanel('Report Builder: View schedules');
          break;
      }

      this.$emit('update:table', table);
    }
  }
}
</script>

<style scoped>
.reporting_head {
  display: flex;
  flex-wrap: wrap;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: 2rem;
}

.heading {
  line-height: 1.25;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 2.5rem;
  font-weight: 700;
  margin-right: auto;
}

.btn_grp {
  display: flex;
}

.btn_grp .btn {
  margin-bottom: 0;
  display: flex;
  -webkit-box-align: center;
  padding: .75rem 1.5rem;
  align-items: center;
  font-size: 16px;
  border-radius: .75rem;
  line-height: 1.277;
  text-align: center;
  letter-spacing: -0.5px;
  text-transform: capitalize;
}

.btn_grp .btn span {
  margin-left: .625rem;
  transition: .3s;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: -0.042em;
  font-size: 1.125rem;
}

.btn.primary_btn {
  border: 2px solid #37B2A8;
  background-color: #FFFFFF;
}

.btn.primary_btn span {
  color: #37B2A8;
}

.btn.primary_btn:hover {
  background-color: #cccccc;
}

.btn.secondary_btn {
  background-color: #37B2A8;
}

.btn.secondary_btn span {
  color: white;
}

.btn.secondary_btn:hover {
  background-color: #0A8080;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
